import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.push.js";
import ElSpLeft from './el-sp-left.vue';
import ElSpCenter from './el-sp-center.vue';
import ElSpRight from './el-sp-right.vue';
import { mixin as pluginMinx } from '@/plugin/index.min.js';
import _ from "lodash";
export default {
  name: 'WeSpIndex',
  components: {
    ElSpLeft,
    ElSpCenter,
    ElSpRight
  },
  mixins: [pluginMinx],

  data() {
    return {
      // 接收用户传递的参数
      settings: {},
      selectedUserList: [],
      callback: null,
      openDialog: false,
      // this.open,
      action: '',
      // left
      tabData: [],
      treeData: [],
      currentTreeNode: {},
      currentTabId: '',
      treeDataObj: {},
      // 保存每个标签页的treeData，以防重复查找
      tabIdObj: {},
      // 保存每个标签页的选中节点，以便于切回去之后定位查询
      // center
      theadData: {},
      positionList: [],
      positionCode: '',
      // right
      selected: [],
      // this.selectedUserList,
      isActivedAll: false,
      // 控制是否全选/清除
      // 查询参数
      queryValue: '',
      currentPage: 1,
      users: [],
      copy_users: [],
      total: 0,
      // 添加到群组
      groupProps: {
        openGroupDialog: false,
        selectValue: '',
        groups: [],
        inputValue: ''
      },
      validaRules: {
        // selectValue: { required: true, message: '请选择', trigger: 'change'},
        inputValue: {
          required: true,
          message: '请输入',
          trigger: 'blur'
        }
      }
    };
  },

  computed: {
    options() {
      // 允许插件对默认和传入的 props 进行预处理
      const propKeys = this.$options._propKeys;
      const propsData = propKeys.reduce((ret, item) => ({ ...ret,
        [item]: this[item]
      }), {});
      const pluginProps = this.$applyPluginsWaterfall('props', propsData); // 如果传递了plugin，则从plugin中取配置，否则从setting中取

      return pluginProps.plugins ? pluginProps : this.settings;
    },

    isShowLoadmore() {
      const {
        users,
        total
      } = this;
      return users.length < total;
    },

    groupTabName() {
      // 获取添加到XX群组的标题
      const {
        tabData,
        options
      } = this;
      let name = '';

      if (tabData) {
        tabData.forEach(item => {
          if (item.id === options.addButtonTabId) {
            name = item.name;
          }
        });
      }

      return name;
    }

  },

  mounted() {
    this.$nextTick(async () => {
      // 初始化插件
      this.$applyPlugins('init'); // 查询left，头部tab标签

      let {
        showDepartment
      } = this.options;

      if (showDepartment) {
        this.tabData = this.$applyPluginsWaterfall('fetch-tabs') || [{
          id: '0',
          name: '组织机构',
          showPosition: false
        }];
      } else {
        this.copy_users = _.cloneDeep(this.users || []);
      } // 查询center，theadData，列名


      this.theadData = this.$applyPluginsWaterfall('fetch-thead') || {
        name: '姓名',
        id: '工号',
        dept: '组织机构'
      }; // 查询右侧人员信息，根据工号

      if (this.selectedUserList && this.selectedUserList.length > 0) {
        this.selected = (await this.$applyPluginsAsyncWaterfall('fetch-user-by-id', this.selectedUserList)) || [];
      }
    });
  },

  methods: {
    async fetchLeft(query = {}) {
      if (Array.isArray(this.treeDataObj[query.tabId])) {
        this.treeData = this.treeDataObj[query.tabId];
      } else {
        // 查询left组织机构信息
        const result = await this.$applyPluginsAsyncWaterfall('fetch-left', query);

        if (Array.isArray(result)) {
          // 兼容OA本地插件，返回值的第二个元素为showPosition
          if (Array.isArray(result[0]) && typeof result[1] === 'boolean') {
            const [treeData, showPosition] = result;
            this.treeData = treeData;
            this.options.showPosition = showPosition;
          } else {
            this.treeData = result;
          } // 只有第一次加载才查询，后面每次不再查询最左侧组织架构信息


          this.treeDataObj[query.tabId] = this.treeData;
        }
      }

      if (this.treeData.length > 0) {
        // 第一次渲染展开第一个节点，如果切换过标签则展开之前选中的节点
        const key = this.tabIdObj[query.tabId] ? this.tabIdObj[query.tabId] : this.treeData[0].id;
        this.currentTreeNode = {
          id: key
        };
        this.$refs['el-sp-left'].expandedKeys.push(key);

        if (this.options.showPosition) {
          this.$refs['el-sp-center'].position = this.positionCode;
        } // 查询人员信息
        //this.reloadCenter()


        this.currentPage = 1;
        this.users = [];
        let currentDepart = this.treeData.length > 0 && this.treeData[0].id || false;
        this.fetchCenter({
          currentDepart: currentDepart
        }); // 查询任职信息

        this.fetchPosition();
      }
    },

    async fetchCenter(query = {}) {
      // 查询center,人员信息
      let result = await this.$applyPluginsAsyncWaterfall('fetch-center', {
        pageNumber: this.currentPage,
        pageSize: this.pageSize ? this.pageSize : 200,
        tabId: this.currentTabId,
        positionCode: this.positionCode,
        ...this.currentTreeNode,
        ...query
      });

      if (Array.isArray(result)) {
        const [datas, total] = result;

        if (Array.isArray(datas) && typeof total === 'number') {
          this.users = [...this.users, ...datas];
          this.total = total;
        }
      }
    },

    async fetchCenterNoDepart(query = {}) {
      let result = [];

      if (!this.queryValue) {
        this.copy_users = this.users;
        this.total = this.users.length;
        return;
      }

      result = this.copy_users.filter(el => query.searchInput ? el.id.includes(query.searchInput) || el.name.includes(query.searchInput) : true);
      this.copy_users = result;
      this.total = result.length;
    },

    async fetchPosition() {
      if (this.options.showPosition) {
        this.positionList = await this.$applyPluginsAsyncWaterfall('fetch-position', this.currentTreeNode);
        let deptIds = this.options.deptIds;
        deptIds = deptIds.length > 0 ? deptIds.filter(el => el !== '1' && el !== '2' && el !== 'xld') : [];
        this.positionList = deptIds.length ? this.positionList.filter(el => deptIds.includes(el.value)) : this.positionList;
      }
    },

    reloadCenter() {
      this.currentPage = 1;
      this.users = []; //this.fetchCenter()

      this.fetchCenter({
        searchInput: this.queryValue,
        currentDepart: this.currentTreeNode.id
      });
    },

    treeItemSelect_p(data) {
      this.currentTreeNode = data;
      this.tabIdObj[this.currentTabId] = data.id;
      this.$refs['el-sp-center'].position = '';
      this.positionCode = ''; // 查询人员信息

      this.reloadCenter(); // 查询任职信息

      this.fetchPosition();
    },

    clickTab_p(tab) {
      this.positionCode = "";
      this.currentTabId = tab;
      this.options.showPosition = this.tabData.find(el => el.id === tab).showPosition;
      this.fetchLeft({
        tabId: tab
      });
    },

    changePosition(val) {
      if (this.options.showPosition) {
        this.positionCode = val;
        this.currentPage = 1;
        this.users = []; //this.fetchChangePosition();

        this.fetchCenter();
      }
    },

    check_p(data) {
      if (Array.isArray(data)) {
        // checkbox
        data.forEach(obj => {
          const index = this.selected.findIndex(el => el.id === obj.id);

          if (index === -1) {
            if (obj._isSelected) this.selected.push(obj);
          } else {
            if (!obj._isSelected) {
              this.selected.splice(index, 1);
            }
          }
        });
      } else {
        // radio
        this.selected = [];
        this.selected.push(data);
      }
    },

    searchUser(element) {
      if (!element) return;
      let {
        showDepartment
      } = this.options;

      if (showDepartment) {
        if (element === 'loadmore') {
          this.currentPage += 1;
        } else {
          this.currentPage = 1;
          this.users = [];
        }

        this.fetchCenter({
          searchInput: this.queryValue,
          currentDepart: this.currentTreeNode.id
        });
      } else {
        this.fetchCenterNoDepart({
          searchInput: this.queryValue
        });
      }
    },

    handleDeleteAll() {
      // 清空
      this.selected = [];
    },

    handleDelete(data) {
      // 删除单个
      if (Object.prototype.toString.call(data) === '[object Object]') {
        this.selected = this.selected.filter(obj => {
          return data.id !== obj.id;
        });
      } else {
        const obj = this.splitSelected();
        this.selected = obj.noneActived;
      }
    },

    selectAllOrClear() {
      const flag = !this.isActivedAll;
      this.selected.forEach((item, index) => {
        item.active = flag;
        this.$set(this.selected, index, item);
      });
      this.isActivedAll = flag;
    },

    checkItem(user) {
      const index = this.selected.indexOf(user);

      if (user.active === true) {
        user.active = false;
        this.$set(this.selected, index, user);
        this.isActivedAll = false;
      } else {
        user.active = true;
        this.$set(this.selected, index, user);
        const activeUsers = this.selected.filter(item => {
          return item.active === true;
        });

        if (activeUsers.length === this.selected.length && activeUsers.length !== 0) {
          this.isActivedAll = true;
        } else {
          this.isActivedAll = false;
        }
      }
    },

    setTop() {
      if (!this.isActivedAll) {
        const obj = this.splitSelected();
        this.selected = obj.actived.concat(obj.noneActived);
      }
    },

    setBottom() {
      if (!this.isActivedAll) {
        const obj = this.splitSelected();
        this.selected = obj.noneActived.concat(obj.actived);
      }
    },

    moveUp() {
      if (!this.isActivedAll) {
        const obj = this.splitSelected();
        obj.actived.forEach((o, i) => {
          let index = this.selected.indexOf(o) - 1;
          if (index < 0) index = 0;

          if (obj.actived.indexOf(obj.noneActived[index]) === -1) {
            obj.noneActived.splice(index, 0, o);
          } else {
            obj.noneActived.splice(index + 1, 0, o);
          }
        });
        this.selected = obj.noneActived;
      }
    },

    moveDown() {
      if (!this.isActivedAll) {
        const obj = this.splitSelected();
        obj.actived.forEach((o, i) => {
          const index = this.selected.indexOf(o) + 1;
          obj.noneActived.splice(index, 0, o);
        });
        this.selected = obj.noneActived;
      }
    },

    splitSelected() {
      const actived = [];
      const noneActived = [];
      this.selected.forEach((obj, i) => {
        if (obj.active) {
          actived.push(obj);
        } else {
          noneActived.push(obj);
        }
      });
      return {
        actived: actived,
        noneActived: noneActived
      };
    },

    confirm() {
      if (this.options.required && this.selected.length === 0) {
        this.$message.error('没有选择任何人员，请点击取消或点击弹窗右上角关闭按钮进行关闭');
        return false;
      }

      this.action = 'confirm';
      this.doClose();
    },

    cancel() {
      this.action = 'cancel';
      this.doClose();
    },

    // 对话框关闭事件，点击右上角的叉或者是遮罩触发
    closeDialog() {
      this.action = 'close';
      this.doClose();
    },

    doClose() {
      this.openDialog = false;
      setTimeout(() => {
        this.callback(this.selected, this.action);
      });
      this.$destroy(true);

      if (this.$el.parentNode) {
        this.$el.parentNode.removeChild(this.$el);
      }
    },

    resetForm() {
      this.$nextTick(() => {
        this.$refs.groupProps.resetFields();
      });
    },

    async openAddToGroupDialog() {
      this.groupProps.openGroupDialog = true;
      this.resetForm();
      const result = await this.$applyPluginsAsyncWaterfall('fetch-left', {
        tabId: this.options.addButtonTabId
      });

      if (result) {
        this.groupProps.groups = result || [];
      }
    },

    addToGroup() {
      this.$refs.groupProps.validate(async valid => {
        if (valid) {
          this.groupProps.openGroupDialog = false;
          await this.$applyPluginsAsyncWaterfall('fetch-add-group', {
            datas: this.selected,
            BIZ_ID: this.groupProps.selectValue || -1,
            TITLE: this.groupProps.inputValue
          });
        }
      });
    },

    changeSelect(value) {
      if (value) this.groupProps.inputValue = '';
    },

    changeInput(value) {
      if (value) this.groupProps.selectValue = '';
    }

  }
};